import { ACTION_CATEGORY_LABELS, ACTION_ICON_FALLBACK } from '../config/actionsConfig';

/** Map icon_name slugs from Supabase to a display glyph (emoji). */
const ICON_NAME_MAP = {
  globe: '🌍',
  earth: '🌍',
  bottle: '🚰',
  cup: '☕',
  bag: '🛍️',
  lunch: '🥪',
  leaf: '🌿',
  recycle: '♻️',
  bike: '🚲',
  bus: '🚌',
  tree: '🌳',
};

/**
 * @param {string|null|undefined} iconName
 * @returns {string}
 */
export function getActionIconGlyph(iconName) {
  if (!iconName || typeof iconName !== 'string') return ACTION_ICON_FALLBACK;
  const trimmed = iconName.trim();
  if (!trimmed) return ACTION_ICON_FALLBACK;
  const lower = trimmed.toLowerCase();
  if (ICON_NAME_MAP[lower]) return ICON_NAME_MAP[lower];
  if (trimmed.length <= 8 && /^\p{Extended_Pictographic}+$/u.test(trimmed)) return trimmed;
  return ACTION_ICON_FALLBACK;
}

export function formatCategoryLabel(category) {
  if (!category) return null;
  const key = String(category).toLowerCase().replace(/\s+/g, '-');
  return ACTION_CATEGORY_LABELS[key] || category;
}
